import {Injectable}       from '@angular/core';
import {
    CanActivate, Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    CanActivateChild,
    NavigationExtras,
    CanLoad, Route, ActivatedRoute, ParamMap
}                           from '@angular/router';

import {Observable, of} from 'rxjs';
import { map ,concatMap} from "rxjs/operators";

import { PermissionsToRoutes } from './permissionsToAllRoutes.service';


@Injectable({
    providedIn: "root"
  })
export class AuthGuard implements CanActivate, CanActivateChild {
    constructor(private permissionServ: PermissionsToRoutes, private router: Router, private route: ActivatedRoute) {
    }


    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):Promise<boolean>{
        let listurl:any = []
        this.listUrl(route,state,listurl)
        return this.permissionServ.hasPermissions(listurl).then(i=>{
            if(!i)
            {
                let redirectAfterLogin = route.url.map(i=>i.path).join('/')
                localStorage.setItem('redirectAfterLogin',redirectAfterLogin)
                this.router.navigate(['login'])
                console.log('window.location.href',window.location.href);
                console.log('window.location.href',route);
                
            }
            return i
        })
        // console.log(listurl)
              
        // return true

    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

        return this.canActivate(route, state);
    }

    listUrl(route: ActivatedRouteSnapshot, state: RouterStateSnapshot,listurl:string[])
    {
        
        if(route.parent && route.parent.routeConfig)
            this.listUrl(route.parent,state,listurl)
        
        if(route?.routeConfig?.path)
            listurl.push(route.routeConfig.path)

        return listurl
        
    }



}
